import React from "react";
import UserScreenWindow from "../Components/UserScreenWindow";

function Paynow() {
  return <UserScreenWindow label="Bills Payment">Paynow</UserScreenWindow>;
}

export default Paynow;
